import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ToggleContext = createContext({ toggles: {}, refresh: () => {}, isOn: () => true, ready: false });

export function ToggleProvider({ children }) {
    const [toggles, setToggles] = useState({});
    const [ready, setReady] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/toggles");
            setToggles(data || {});
        } catch (e) {
            // Even on failure, allow site to render with all-on default
            setToggles({});
        } finally {
            setReady(true);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const isOn = useCallback(
        (key) => {
            // default to true if key missing (graceful)
            return toggles[key] !== false;
        },
        [toggles]
    );

    return (
        <ToggleContext.Provider value={{ toggles, refresh, isOn, ready }}>
            {children}
        </ToggleContext.Provider>
    );
}

export function useToggles() {
    return useContext(ToggleContext);
}

export function useToggle(key) {
    const { isOn } = useContext(ToggleContext);
    return isOn(key);
}
